import type { Iso3166TwoDigitCountryCode } from '@onefootprint/request-types';
import type { MaskConfig } from '../../../../utils/mask-utils';

export const preferences: Partial<
  Record<
    Iso3166TwoDigitCountryCode,
    {
      placeholder: string;
      mask: MaskConfig;
    }
  >
> = {
  US: {
    placeholder: '(123) 456-7890',
    mask: {
      numericOnly: true,
      delimiters: ['(', ') ', '-'],
      blocks: [0, 3, 3, 4],
    },
  },
  CA: {
    placeholder: '(123) 456-7890',
    mask: {
      numericOnly: true,
      delimiters: ['(', ') ', '-'],
      blocks: [0, 3, 3, 4],
    },
  },
};

export const defaultPreference = {
  placeholder: '',
  mask: {
    numericOnly: true as const,
  } as MaskConfig,
};
